// extracted by mini-css-extract-plugin
export default {"containerStyle":"GrowBusiness_containerStyle__372YK","content":"GrowBusiness_content__zIA4t"};